import { Divider, Empty, Flex, Form, Skeleton, Spin, Typography } from "antd";

import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useEffect } from "react";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { requestWithNotify } from "utils";

export const TemplatesCodeModal = observer(({ type }: { type: string }) => {
  const { actionModals, templates } = useStores();
  const { openNotification } = useNotificationContext();

  useEffect(() => {
    requestWithNotify({
      fetchFn: () => templates.getTemplateCodes(type),
      openNotification: openNotification,
    });
  }, [type, templates, openNotification]);

  const handleCloseModal = () => {
    actionModals.closeAll();
  };

  return (
    <Flex vertical gap="large">
      <Flex vertical>
        <Typography.Title>Список кодов</Typography.Title>
        <Divider style={{ margin: 0 }} />
        {templates.templateCodesStatuses.loading ? (
          <Flex justify="center" vertical gap="small">
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
          </Flex>
        ) : (
          <Flex vertical gap="small">
            <Typography.Title level={5}>
              {templates.templateCodes?.type && templates.templateCodes?.description}
            </Typography.Title>
            <Flex vertical gap="small">
              {templates.templateCodes?.fields && templates.templateCodes?.fields.length > 1 ? (
                templates.templateCodes?.fields.map((code) => {
                  return (
                    <Flex key={code.id} justify="space-between">
                      <Typography.Text className="text-description">{code.templateParameterName}</Typography.Text>
                      <Typography.Text style={{ width: "250px" }} strong>
                        {code.description}
                      </Typography.Text>
                    </Flex>
                  );
                })
              ) : (
                <Empty description="Нет данных по кодам" />
              )}
            </Flex>
          </Flex>
        )}
      </Flex>

      <Form.Item>
        <CustomButton htmlType="button" style={{ width: "100%" }} onClick={handleCloseModal}>
          Закрыть
        </CustomButton>
      </Form.Item>
    </Flex>
  );
});
